module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/vi/6-10cc42bfd46cfac3d544eeaa17a55429.jpg";